module.exports = __webpack_public_path__ + "img/cruelty-free.c51b5c76.jpg";